// /shop/:category renders the same Shop component with the category from URL params
import Shop from "./Shop";

export default function ShopCategory() {
  return <Shop />;
}
